import Vue from 'vue'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'
import Home from '@/components/Home'
import Faq from '@/components/Faq'
import Product from '@/components/Product'
import Contact from '@/components/Contact'
import Lotos from '@/components/Lotos'

Vue.use(Router)


const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: (resolve) => require(['../components/Home.vue'], resolve),
      meta: {title: 'EZARCH 樂土專業販售'}
    },
    {
      path: '/faq',
      name: 'Faq',
      component: (resolve) => require(['../components/Faq.vue'], resolve),
      meta: {title: '樂土Q&A - EZARCH 樂土專業販售'}
    },
    {
      path: '/product',
      name: 'Product',
      component: (resolve) => require(['../components/Product.vue'], resolve),
      meta: {title: '樂土產品列表 - EZARCH 樂土專業販售'}
    },
    {
      path: '/contact',
      name: 'Contact',
      component: (resolve) => require(['../components/Contact.vue'], resolve),
      meta: {title: '聯絡我們 - EZARCH 樂土專業販售'}
    },
    {
      path: '/lotos',
      name: 'Lotos',
      component: (resolve) => require(['../components/Lotos.vue'], resolve),
      meta: {title: '什麼是樂土？ - EZARCH 樂土專業販售'}
    }
  ]
})

Vue.use(VueAnalytics, {
  id: 'UA-39498232-1',
  router
})

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title;
  next()
})
export default router





// WEBPACK FOOTER //
// ./src/router/index.js